<template>
  <div
    class="bootcamp-results__upcoming"
    v-if="(upcoming && upcoming.length) || (current && current.length)"
  >
    <h3 class="bootcamp-results__title">
      Upcoming Bootcamps
    </h3>
    <div class="bootcamp-results__upcoming-body">
      <div
        v-for="item in current"
        :key="item.objectID"
        class="bootcamp-results__item"
      >
        <BootcampTile
          v-bind="{
            bootcamp: item,
            formatDateForBootcamp,
            renderMarkdown,
            epoch: true,
            current: true,
          }"
          @element-rend="handleRememberPosition"
        />
      </div>
      <div
        v-for="item in upcoming"
        :key="item.objectID"
        class="bootcamp-results__item"
      >
        <BootcampTile
          v-bind="{
            bootcamp: item,
            formatDateForBootcamp,
            renderMarkdown,
            epoch: true,
            isNext: item.start_datetime === nextBootcampDate,
          }"
          @element-rend="handleRememberPosition"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { compareAsc } from 'date-fns'
import BootcampTile from '@/components/layout/BootcampTile.vue'
import { formatDateForBootcamp } from '@/helpers'

const marked = require('marked')

export default {
  name: 'BootcampResults',
  components: { BootcampTile },
  props: { items: { type: Array, required: true } },
  data: () => {
    return {
      formatDateForBootcamp,
    }
  },
  computed: {
    current() {
      return this.items.filter(b => {
        return (
          compareAsc(new Date(b.start_datetime * 1000), new Date()) < 0 &&
          compareAsc(new Date(b.end_datetime * 1000), new Date()) >= 0
        )
      })
    },
    upcoming() {
      return this.items.filter(b => {
        return compareAsc(new Date(b.start_datetime * 1000), new Date()) > 0
      })
    },
    nextBootcampDate() {
      try {
        const nextDate = Math.min(
          ...this.upcoming?.map(b => {
            return new Date(b.start_datetime)
          })
        )
        return nextDate
      } catch (error) {
        return null
      }
    },
  },
  methods: {
    renderMarkdown(string) {
      return marked(string)
    },
    handleRememberPosition(elId) {
      this.$emit('child-element-render', elId)
    },
  },
}
</script>

<style lang="scss" scoped>
.bootcamp-results {
  &__item {
    display: flex;
    align-items: center;
    min-width: 100%;
    min-height: 80px;
    margin: 5px 0 0 0;
    @include medium-device {
      margin: 0 0 10px 0;
      padding: 0 0 5px 15px;
    }

    @include tablet {
      padding-left: 0;
    }
  }
  &__title {
    color: var(--white);
    font-size: rem(20px);
    font-weight: bold;
    width: 100%;
  }
  &__upcoming {
    width: 100%;
    &-body {
      display: flex;
      overflow: scroll;
      gap: 10px;
      @include mobile {
        flex-direction: column;
      }
    }
  }
}
</style>
